<div class="config-editor-header">
  <i class="mr-2 fa fa-code"></i>

  <span class="text-xl font-medium">Konfigurationseditor</span>

  <div
    jmlFavoriteButton
    [favoriteId]="'config-editor'"
    [favoriteName]="'Konfigurationseditor'"
    [favoriteIcon]="'fa fa-code'"
    [favoriteRoute]="'/configuration/dto-config-editor'"
  ></div>

  <button
    pButton
    (click)="saveConfig()"
    [disabled]="currentConfigName === undefined"
    icon="pi pi-save"
    class="p-button-success"
  ></button>
</div>

<div class="content-container border-1 border-solid border-300" style="height: 700px">
  <div style="height: 698px; width: calc(100% - 15rem); float: right">
    <ace
      [config]="aceconfig"
      [disabled]="!enableEditor"
      (blur)="onEditorBlur($event)"
      (focus)="onEditorFocus($event)"
      (valueChange)="onValueChange($event)"
      (selectionChange)="onSelectionChange($event)"
      [(value)]="currentConfig"
      theme="github"
      mode="json"
    >
    </ace>
  </div>
  <div class="bg-white w-15rem" style="height: 698px">
    <p-listbox
      [options]="dtoConfigs"
      (onChange)="selectedConfigChanged($event)"
      [style]="{ border: '0 none' }"
      [listStyle]="{ 'max-height': '698px', width: '15rem' }"
    >
    </p-listbox>
  </div>
</div>
